<div class="flex flex-col h-full">
  <div
    class="external-main-content items-center justify-center flex-1 p-6 text-center sm:px-20 md:px-24 md:py-8 dark:text-white bg-grey-FA dark:bg-box-dark"
  >
    <div class="modal-body action-modal-body">
      <div class="modal-content">
        <img
          *ngIf="logoPath"
          [src]="logoPath"
          [alt]="mission?.mission_logo_alt_text"
          class="logo"
        />
        <h2
          *ngIf="title"
          class="dark:text-white text-xl mb-2 lg:mb-0 font-bold lg:text-2xl"
          [innerHTML]="title | markdown2html : { secure: true }"
        ></h2>
        <p
          *ngIf="description"
          [innerHTML]="description | translate | markdown2html : { secure: true }"
          [ngClass]="{ 'mb-6 md:mb-8': !closeMessage }"
          class="dark:text-white text-sm lg:text-lg font-semibold"
        ></p>
        <p
          *ngIf="closeMessage"
          class="dark:text-white text-sm lg:text-lg font-semibold mb-6 md:mb-8"
        >
          {{ closeMessage }}
        </p>
        <p *ngIf="redirectUrl" class="text-sm lg:text-lg font-semibold mb-6">
          <a [href]="redirectUrl" class="text-blue-500 no-underline ml-0.5">
            Click here
          </a>
          <span class="dark:text-white">
            if you're are not automatically redirected.
          </span>
        </p>
        <button
          *ngIf="isPreview"
          [disabled]="isLoading"
          (click)="onRestartSurvey()"
        >
          Restart
        </button>
      </div>
    </div>
  </div>
</div>
